import { HttpErrorResponse } from '@angular/common/http';
import { createActionGroup, emptyProps, props } from '@ngrx/store';
import { Quote, TopInstrument } from '@zero/shared/util-models';
import { FamousIndication } from 'constants/shared-constants';

export const homeActions = createActionGroup({
  source: 'Home',
  events: {
    'set famous indications': props<{ indications: FamousIndication[] }>(),
    'update famous indications': props<{ indications: FamousIndication[] }>(),
    'subscribe to indication quotes': emptyProps(),
    'unsubscribe from indication quotes': emptyProps(),
    'update indication quotes': props<{ quotes: Record<string, Quote> }>(),
    'load top instruments': emptyProps(),
    'subscribe to top instruments quotes': emptyProps(),
    'unsubscribe from top instruments quotes': emptyProps(),
    'update top instruments quotes': props<{ quotes: Record<string, Quote> }>(),
    'update top instruments': props<{ topInstruments: TopInstrument[] }>(),
  },
});

export const homeApiActions = createActionGroup({
  source: 'Home API',
  events: {
    'load top instruments successful': props<{ topInstruments: TopInstrument[] }>(),
    'load top instruments failed': props<{ error: HttpErrorResponse }>(),
  },
});

export const homeActionsIgnoreList = [
  homeActions.updateFamousIndications.type,
  homeActions.updateIndicationQuotes.type,
  homeActions.updateTopInstruments.type,
  homeActions.updateTopInstrumentsQuotes.type,
];
